<template>
  <div class="campaign-financials-body">
    <div class="row">
      <div class="col-md-7 col-12">
        <div class="client-payment-setup-form-wrapper">
          <div class="d-flex flex-wrap flex-md-nowrap flex-column" style="gap:16px;">
            <div class="w-100" v-if="userType !== 'client'">
              <div class="client-payment-modal-form-label">Setup Fee</div>
              <div>
                <base-input
                  type="text"
                  placeholder="0"
                  addon-left-icon="fas fa-dollar-sign"
                  class="campaign-cost-input"
                  :value="platformFeeModel"
                  :readonly="leadspeekInputReadOnly"
                  @blur="handleFormatCurrency('platformFee')"
                  @input="onPlatformFeeInput"
                  @keyup.native="emitRecalculate"
                  @keydown.native="restrictInput"
                  @copy.prevent
                  @cut.prevent
                  @paste.prevent
                />
              </div>
              <div v-if="false" class="client-payment-modal-form-helper-text">
                <span>Your Wholesale Setup Fee Is $<span>{{ mPlatformFee }}</span></span>
              </div>
            </div>

            <div class="w-100" v-if="userType !== 'client'">
              <div class="client-payment-modal-form-label">
                Monthly Campaign Fee
              </div>
              <div>
                <base-input
                  type="text"
                  placeholder="0"
                  addon-left-icon="fas fa-dollar-sign"
                  class="campaign-cost-input"
                  :value="minCostMonthModel"
                  :readonly="leadspeekInputReadOnly"
                  @blur="handleFormatCurrency('minCostMonth')"
                  @input="onMinCostMonthInput"
                  @keyup.native="emitRecalculate"
                  @keydown.native="restrictInput"
                  @copy.prevent
                  @cut.prevent
                  @paste.prevent
                />
              </div>
              <div v-if="false" class="client-payment-modal-form-helper-text">
                <span>Your Month Wholesale Campaign Fee $<span>{{ mMinCostMonth }}</span></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-5 col-12">
        <div class="summary-card p-3" style="background:#f7f8fa;border-radius:10px;">
          <div class="mb-2"><strong>Summary</strong></div>

          <div v-if="false" class="py-2" style="border-top:1px solid #e9ecef;border-bottom:1px solid #e9ecef;">
            <div class="mb-2"><strong>Cost Breakdown</strong></div>
            <div class="d-flex justify-content-between">
              <small>1. Your Set Up fee is</small>
              <small>${{ formatPrice(platformFeeModel) }}</small>
            </div>
            <div class="d-flex justify-content-between">
              <small>2. Your per month campaign fee is</small>
              <small>${{ formatPrice(minCostMonthModel) }}</small>
            </div>
          </div>

          <div class="py-2" style="border-bottom:1px solid #e9ecef;" v-if="userType !== 'client'">
            <div class="mb-2"><strong>Profit Breakdown</strong></div>
            <div class="d-flex justify-content-between">
              <small>1. Your Set Up Fee Profit</small>
              <small :style="{color: Number(tPlatformFee) < 0 ? '#d9534f' : '#222'}">${{ formatPrice(Number(platformFeeModel) - Number(mPlatformFee)) }}</small>
            </div>
            <div class="d-flex justify-content-between">
              <small>2. Your Monthly Fee profit</small>
              <small :style="{color: Number(tMinCostMonth) < 0 ? '#d9534f' : '#222'}">${{ formatPrice(Number(minCostMonthModel) - Number(mMinCostMonth)) }}</small>
            </div>
          </div>

          <div class="mt-3">
            <div v-if="false" class="p-3 align-items-center d-flex h-100" style="background:#fff;border-radius:10px;border:1px solid #eef1f4; gap: 4px;">
              <strong class="flex-grow-1" style="font-size: 14px;">Your estimate cost per month is</strong>
              <span class="float-right">${{ formatPrice(estimateCost) }}</span>
            </div>
            <div v-if="false" class="p-3 mt-2 align-items-center d-flex h-100" style="background:#fff;border-radius:10px;border:1px solid #eef1f4; gap: 4px;" >
              <strong class="flex-grow-1" style="font-size: 14px;">Your estimate profit per month is</strong>
              <span :style="{color: '#1e9e40'}">${{ formatPrice(tProfit) }}</span>
            </div>
            <div class="p-3 mt-2 h-100" style="background:#fff;border-radius:10px;border:1px solid #eef1f4; gap: 4px;" >
              The client will be charged an initial fee <strong>${{ formatPrice(platformFeeModel) }}</strong> at the start of the campaign, and after 30 days, a recurring monthly charge of <strong>${{ formatPrice(minCostMonthModel) }}</strong> will apply.
              <!-- <strong class="flex-grow-1" style="font-size: 14px;">Your estimate profit per month is</strong>
              <span :style="{color: '#1e9e40'}">${{ formatPrice(tProfit) }}</span> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: 'CampaignFinancials',
  props: {
    userType: { type: String, default: '' },
    txtLeadService: { type: String, default: '' },
    leadspeekInputReadOnly: { type: Boolean, default: false },
    platformFee: { type: [String, Number], required: true },
    minCostMonth: { type: [String, Number], required: true },
    mPlatformFee: { type: [String, Number], default: 0 },
    mMinCostMonth: { type: [String, Number], default: 0 },
    tPlatformFee: { type: [String, Number], default: 0 },
    tMinCostMonth: { type: [String, Number], default: 0 },
    selectsPaymentTerm: { type: Object, default: () => ({}) },
    prepaidType: { type: String, default: '' },
    contiDurationSelection: { type: Boolean, default: false },
    limitLead: { type: [String, Number], default: 0 },
    costPerLead: { type: [String, Number], default: 0 },
    tFreq: { type: [String, Number], default: 4 },
    tProfit: { type: [String, Number], default: 0 }
  },
  computed: {
    platformFeeModel() { return this.platformFee; },
    minCostMonthModel() { return this.minCostMonth; },
    estimateCost() {
      const cpl = Number(this.costPerLead || 0);
      const lpd = Number(this.limitLead || 0);
      const pf = Number(this.platformFee || 0);
      const tFreq = Number(this.tFreq || 0);

      // Mirrors existing parent calculation used in the modal
      const base = (cpl * lpd) * 7;
      const total = this.prepaidType === 'continual'
        ? (this.contiDurationSelection ? (base * tFreq) + pf : base + pf)
        : base + pf;

      return this.safePrice(total);
    }
  },
  methods: {
    emitRecalculate() {
      this.$emit('recalculate');
    },
    onPlatformFeeInput(val) {
      this.$emit('update:platformFee', val);
    },
    onMinCostMonthInput(val) {
      this.$emit('update:minCostMonth', val);
    },
    restrictInput(event) {
      const input = event.target.value || '';
      const char = event.key;
      if (['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(char)) return;
      if (!/[0-9]/.test(char) && char !== '.') event.preventDefault();
      if (char === '.' && input.includes('.')) event.preventDefault();
    },
    formatPrice(value) {
      const n = Number(value);
      if (isNaN(n)) return '0';
      const val = (n / 1).toFixed(2);
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    safePrice(value) {
      return this.formatPrice(value == null || value === '' ? 0 : value);
    },
    handleFormatCurrency(field){
      const validInput = /^[0-9]*(\.[0-9]*)?$/;

      if(!validInput.test(this[field])){
        this[field] = 0
      }

      if(this[field] == ""){
        this[field] = 0
      }
    }
  }
}
</script>

<style scoped>
.campaign-cost-input input {
  font-weight: 500;
}
.summary-card .float-right {
  float: right;
}
</style>
